/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentWithRelations } from './normativeDocumentWithRelations';
import { RoleWithRelations } from './roleWithRelations';
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: NormativeDocumentPermissionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface NormativeDocumentPermissionWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    documentId: string;
    userId?: number;
    roleId?: number;
    /**
     * view | download | manage
     */
    level: string;
    document?: NormativeDocumentWithRelations;
    user?: UserWithRelations;
    role?: RoleWithRelations;
}

